import { getTitleText } from '@mobi/account/Areas/SignUp/Utils/BonusOffer'
import { Campaign } from '@mobi/betslip/types'
import { dayjs } from '@mobi/utils/date'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

const defaultData = {
  interaction_type: undefined,
  location: undefined,
  activeTab: undefined,
  offer_available: undefined,
  offer_type: undefined,
  offer_title: undefined,
  offer_expiry: undefined,
  element_clicked: undefined,
  split_type: undefined,
}

export const trackBonusBetsInfoClick = (location: string) => {
  trackEvent(keys.bonuses, { ...defaultData, interaction_type: 'Bonus Bets Info Click', location })
}

export const trackBonusCashInfoClick = (location: string) => {
  trackEvent(keys.bonuses, { ...defaultData, interaction_type: 'Bonus Cash Info Click', location })
}

export const trackBonusTabChange = (activeTab: string, offer_available?: string) => {
  trackEvent(keys.bonuses, {
    ...defaultData,
    interaction_type: 'Tab Change',
    activeTab,
    offer_available,
  })
}

export const trackBonusScreenLoaded = (activeTab: string, offer_available?: string) => {
  trackEvent(keys.bonuses, {
    ...defaultData,
    interaction_type: 'Bonus Screen Loaded',
    activeTab,
    offer_available,
  })
}

export const trackBonusOfferClick = (campaign: Campaign, element_clicked: string) => {
  trackEvent(keys.bonuses, {
    ...defaultData,
    interaction_type: 'Bonus Offer Click',
    offer_type: getTitleText(campaign),
    offer_title: campaign.title,
    offer_expiry: dayjs(campaign.expiry).fromNow(true),
    element_clicked,
  })
}

export const trackConfirmBonusSplit = (split_type: string) => {
  trackEvent(keys.bonuses, { ...defaultData, interaction_type: 'Confirm Bonus Split', split_type })
}
